// CRITICAL TODO: Change this into a utility function instead everywhere throughout our codebase!!!

// This was implemented in specific parts of the codebase instead of as a higher abstraction utility function.
// This was a beginner mistake that has been used throughout our entire codebase...

// Here is why:

// 1. Naming Collisions (Future-Proofing):
// The biggest risk is that a future version of JavaScript (ECMAScript) might introduce a native String.prototype.capitalize() method. 
// If your custom implementation has a different behavior or signature, it could cause unexpected bugs and break your code, or any library that relies on the native behavior.
// Similarly, if you use a third-party library, it might also extend String.prototype with a method of the same name but different functionality, leading to unpredictable behavior (the last one defined usually wins).

// 2. Maintainability and Debugging:
// When others (or your future self) read your code, they might not immediately realize that String.prototype has been modified. 
// This can make debugging difficult, as the behavior of standard objects is altered globally.
// It creates "spooky action at a distance" – a change in one part of your codebase can affect seemingly unrelated parts due to global prototype modification.

// 3. Enumerability Issues (Older Practices):
// In older JavaScript, adding properties to prototypes directly using String.prototype.myMethod = function() {} would make them enumerable. 
// This meant they would show up when you iterated over strings or objects using for...in loops, which could break code that expects only "own" properties. 
// While Object.defineProperty can be used to create non-enumerable properties, this is still a concern.

// 4. "Polluting" the Global Scope:
// Modifying global objects makes your code less modular and creates dependencies that are hard to track. 
// It's like adding a new, permanent feature to every string in your entire application, even if only one small part needs it.
// 
// 5. Subtle Behavioral Differences:
// Native methods are often highly optimized in browser engines. A custom JavaScript implementation might not be as performant.


// The bad guy:
// @ts-ignore
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1) || '';
}

// The good guy: 
// Proper implementation should look something like:

// export function capitalize(string) {
//     return string.charAt(0).toUpperCase() + string.slice(1) || '';
// }

// Usage throughout codebase would change from: string.capitalize() to: capitalize(string)
// Which can be replaced throughout our entire codebase with a simple global search and replace for all js and ts files 
// (except internal polyfills, so be careful doing this change)

// Caution: Might require import statements...